export default "__VITE_ASSET__CQbRZkzS__"